<template>
  <kst-page-print-details page-footer
    v-slot="{ title }"
    @init="handleInit"
  >
    <div class="columns is-mobile">
      <div class="column is-half">
        <Company :data="companyData"/>
      </div>
      <div class="column is-half">
        <div class="is-size-3">{{ title }}</div>
      </div>
    </div>

    <div class="columns is-mobile">
      <div class="column">
        <Details :data="data"/>
      </div>
    </div>

    <Items class="block" :items="data.Items"/>
    <Total class="block" :data="data"/>
  </kst-page-print-details>
</template>

<script>
import Model from "../SpadModel.js";
import Services from "../../../services/Api/SpecialPriceAdjServices.js";

import Details from "./SpadPD_Details.vue";
import Items from "./SpadPD_Items.vue";
import Total from "./SpadPD_Total.vue";
import Company from "../../Company/RelatedPrintDetails/CpRPD.vue";

export default {
  components: {
    Details,
    Items,
    Total,
    Company
  },
  data: () => ({
    data: {},
    companyData: {}
  }),
  methods: {
    /*** by page ***/

    handleInit(id, loadPrint) {
      this.resetData();

      const config = Services.getPrintDetailsData(id);
      loadPrint(config, this.handleInit_Success);
    },
    handleInit_Success(data) {
      this.data = data.Details;
      this.companyData = data.CompanyDetails;

      for (const item of this.data.Items) {
        Model.updateItem(item);
      }
    },

    /*** custom ***/

    resetData() {
      this.data = {};
      this.companyData = {};
    }
  }
}
</script>